import { Form, message } from "antd";
import Dragger from "antd/es/upload/Dragger";
import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import { saveFile } from "../../../features/save/saveSlice";
import { useDispatch } from "react-redux";
import { formatImgPath } from "../../../utils";

function Images({ form }) {
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const [fileUrls, setFileUrls] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const props = {
    name: "file",
    multiple: false,
    accept: "image/*",
    showUploadList: true,

    beforeUpload: async (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        toast.error("Only image files are allowed.");
        return false;
      }

      setFileLoading(true);
      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await dispatch(saveFile(formData));
        if (res?.payload?.success) {
          toast.success(res?.payload?.message);
          const url = res.payload?.targetUrl;
          setFileUrls((prev) => [...prev, url]); // <-- Add this line
        } else {
          message.error(`Upload failed: ${res?.payload?.message}`);
        }
      } catch (err) {
        message.error(`Upload failed`);
        console.error(err);
      } finally {
        setFileLoading(false);
      }

      return false;
    },

    onDrop(e) {
      setFileLoading(false);
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div>
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      > 
        <div className="grid grid-cols-4 gap-3 mt-5">
           <Form.Item
          name=""
          label="Document File"
          rules={[
            {
              required: true,
              message: "Please upload a file",
            },
          ]}
        >
          <Dragger className="attachment" {...props}>
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    d="M25.375 18.125V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5423 9.66667L14.5007 3.625L8.45898 9.66667"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5 3.625V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <p className="ant-upload-text !ml-2">
                Click to upload
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br></br>
                <span className="!mt-[10rem] text-[#667085]">
                  PNG or JPG (max. 800x400px)
                </span>
              </p>
            </div>
          </Dragger>
        </Form.Item>
          {fileUrls?.map((url, index) => (
            <div key={index} className="border rounded overflow-hidden">
              <img
                loading="lazy"
                className="w-full h-[8rem] object-cover"
                src={formatImgPath(url)}
                alt={`uploaded-${index}`}
              />
            </div>
          ))}
        </div>
      </Form>
    </div>
  );
}

export default Images;
